import { useRef, useState, useEffect, useCallback, memo } from "react";
import { DropDownIcon, LucidLoader } from "../../Icons";
import { Checkbox, Input, Tooltip } from "antd";
import { Fragment } from "react";

const truncateText = (text, maxLength) => {
    if (text?.length > maxLength) {
        return text.slice(0, maxLength) + '...';
    }
    return text;
};

export default memo(function SearchWithDropDown({
    isSearch = true, // Changed default to true since we always want search now
    title = "Select Items",
    placeholder = "Search...",
    data = [],
    onSearch,
    onCheckboxClick,
    displayKey = "value",
    maxTextLength = 30,
    maxDropdownHeight = "max-h-48",
    containerClassName = "",
    dropdownClassName = "",
    searchInputClassName = "p-2 border !rounded border-gray-300 w-full outline-none",
    itemClassName = "flex items-center ",
    checkboxClassName = "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500",
    labelClassName = "ml-2 text-sm font-medium text-gray-700",
    isDropdown = true, // Keep dropdown functionality for results
    DropDownComponent,
    getDisplayValue = (item, displayKey) => {
        const displayValue = item[displayKey];
        return typeof displayValue === 'string' ? displayValue : String(displayValue || '');
    },
    checked = (item) => item.checked,
    onChangeValueInput = 'id',
    label = 'abc',
    labelClassNameTop = 'block font-medium text-black',
    isLoadingOn,
}) {
    const dropdownRef = useRef();
    const [searchTerm, setSearchTerm] = useState("");
    const [showResults, setShowResults] = useState(false);
    

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowResults(false);
            }
        };
        if (showResults) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showResults]);

    const handleOnSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        // setShowResults(value.length > 0 || data.length > 0); // Show results when typing or data exists
        onSearch?.(value);
    };

    const handleInputFocus = () => {
        setShowResults(true);
    };

    const handleCheckboxClick = (id) => {
        onCheckboxClick?.(id);
    };

    return (
        <div className={`relative rounded ${containerClassName}`}>
            <div className="text-start">
                {label ? (
                    <label htmlFor={label + title} className={labelClassNameTop}>
                        {label}
                    </label>
                ) : null}
            </div>
            <div className={`relative rounded ${containerClassName}`} ref={dropdownRef}>
                {/* Search Input - now always visible */}

                <div className="relative">
                    <Input
                        id={label + title}
                        type="text"
                        className="flex items-center justify-between gap-x-2 p-2 bg-white cursor-text !rounded border border-gray-400 font-medium text-sm text-gray-700  placeholder:text-black "
                        placeholder={title}
                        value={searchTerm}
                        onChange={handleOnSearch}
                        onFocus={handleInputFocus}
                    />
                    {/* Dropdown icon - now just decorative */}
                    {/* <span className="absolute right-2 top-1/2 transform -translate-y-1/2 h-4 pointer-events-none">
                    <DropDownIcon additionalClasses="h-4 text-gray-400" />
                </span> */}
                </div>

                {/* Results dropdown */}
                {showResults && isDropdown ? (

                    !DropDownComponent ? <div className={`absolute px-1 top-10 py-3 flex flex-col gap-2 z-10 w-full bg-white border ${dropdownClassName}`}>
                        <div className={`flex px-2 w-full flex-col gap-2 ${maxDropdownHeight} overflow-y-auto rounded`}>
                            {data.map((item) => {
                                const displayValue = getDisplayValue(item, displayKey);
                                return (
                                    <div className={itemClassName} key={item._id}>
                                        <Checkbox
                                            type="checkbox"
                                            checked={checked(item)}
                                            onChange={() => handleCheckboxClick(item[onChangeValueInput])}
                                            id={`item-${item._id}`}
                                            className={checkboxClassName}
                                        />
                                        {Tooltip ? (
                                            <Tooltip title={displayValue} placement="top">
                                                <span className="text-sm font-medium text-gray-700 truncate ">
                                                    <label htmlFor={`item-${item._id}`} className={labelClassName}>
                                                        {truncateText(displayValue, maxTextLength)}
                                                    </label>
                                                </span>
                                            </Tooltip>
                                        ) : (
                                            <label htmlFor={`item-${item._id}`} className={labelClassName}>
                                                {truncateText(displayValue, maxTextLength)}
                                            </label>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div> : DropDownComponent ? <div className={`absolute px-1 top-10 py-3 flex flex-col gap-2 z-10 w-full bg-white border ${dropdownClassName}`}>
                        <div className={`flex px-2 w-full flex-col gap-2 ${maxDropdownHeight} overflow-y-auto rounded`}>
                            {
                                isLoadingOn ? <div className="flex items-center justify-center">
                                    <LucidLoader additionalClass={'text-primaryColor'} />
                                </div> : <DropDownComponent />
                            }
                        </div>
                    </div> : null

                ) : null}
            </div>
        </div>
    );
})
